// Gallery project data - Extracted for maintainability
// Categories: Extensions, Roofing, Renovations, Conversions, Brickwork
// Organised with completed/modern projects first

export const projects = [
  // === COMPLETED & MODERN PROJECTS (TOP QUALITY) ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/3bb5bs04_Photo%2020-01-2026%2C%2020%2050%2022.jpg',
    title: 'Single Storey Extension with GRP Roof & Lantern - Completed',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/b3m3tki0_Photo%2020-01-2026%2C%2020%2050%2026.jpg',
    title: 'Single Storey Extension with Patio Doors - Completed',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/y4hpg7fp_Photo%2020-01-2026%2C%2020%2050%2028%20%281%29.jpg',
    title: 'Two-Storey Extension - Beautiful Finish',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/hyt1j8wq_House-3.jpg',
    title: 'Complete Extension & New Roof Installation',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/slmydesr_Photo-20-01-2026%2C-20-50-06.jpg',
    title: 'Finished Extension with Patio Area',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/7si15kvl_Photo-20-01-2026%2C-20-50-34-%281%29.jpg',
    title: 'Modern Extension with Anthracite Bifold Doors',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/wqgr4aoh_Photo-20-01-2026%2C-20-51-46.jpg',
    title: 'Side Extension with Anthracite Bifolds - Aerial View',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/1n3v1oyl_House-1.jpg',
    title: 'Two-Storey Extension with Bifold Doors',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/9yv3qxp8_Photo%2020-01-2026%2C%2020%2051%2054.jpg',
    title: 'New Tiled Roof with Velux Windows - Aerial View',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/b9z9oaln_Photo%2020-01-2026%2C%2020%2051%2058.jpg',
    title: 'Bungalow Extension & Modernisation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/zb85ir99_Photo%2020-01-2026%2C%2020%2050%2023.jpg',
    title: 'Rendered Extension with Patio Doors',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/3i9h5xu6_Photo%2020-01-2026%2C%2020%2050%2025.jpg',
    title: 'Single Storey Extension with Bifolds',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/x89a78a1_Photo%2020-01-2026%2C%2020%2050%2032.jpg',
    title: 'Rear Extension with Bi-fold Doors',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/pqghr5hn_Photo%2020-01-2026%2C%2020%2052%2000.jpg',
    title: 'Rear Extension with Sliding Patio Doors',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/dlzi22jv_Photo%2020-01-2026%2C%2020%2051%2055.jpg',
    title: 'Single-Storey Rear Extension with Solar Panels',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/cthz1604_Photo%2020-01-2026%2C%2020%2050%2032.jpg',
    title: 'Rear Extension with Bi-fold Doors Installed',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/8ok35oy5_Photo-20-01-2026%2C-20-50-07.jpg',
    title: 'Rear Extension with Bi-fold Doors',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/b2n1rzzk_Photo-20-01-2026%2C-20-49-59-%284%29.jpg',
    title: 'Rear Extension with Velux Doors Installed',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/p6z1w6ga_Photo-20-01-2026%2C-20-50-04-%281%29.jpg',
    title: 'Rear Extension with Window Installed',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/qtv0kbf2_Photo-20-01-2026%2C-20-51-54-%281%29.jpg',
    title: 'Rear Extension Window Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/w4tlfr8c_Photo-20-01-2026%2C-20-51-48-%281%29.jpg',
    title: 'Double Side Extension with Windows Installation',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/xppjk2rx_Photo-20-01-2026%2C-20-51-46-%283%29.jpg',
    title: 'Two-Storey Side Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/0dqw8va8_Photo-20-01-2026%2C-20-51-46.jpg',
    title: 'Rear Extension with V-Shaped Roof',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/6i7j88du_Photo%2020-01-2026%2C%2020%2051%2046%20%282%29.jpg',
    title: 'Double Extension with Cladding',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/q3ssj9xq_Photo-20-01-2026%2C-20-51-46-%281%29.jpg',
    title: 'Sloping Roof Single Storey Extension',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/um4f62t3_Photo%2020-01-2026%2C%2020%2050%2002%20%281%29.jpg',
    title: 'Bungalow Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/05uhwnbc_Photo%2020-01-2026%2C%2020%2050%2026.jpg',
    title: 'Premium Patio Installation - Large Format Slabs',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/55w3mm4f_Photo%2020-01-2026%2C%2020%2050%2028.jpg',
    title: 'Side Extension - Quality Brickwork',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/5a7b3oe4_Photo%2020-01-2026%2C%2020%2050%2024.jpg',
    title: 'Side Extension with Brickwork Detail',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/pvl7in30_Photo%2020-01-2026%2C%2020%2050%2032%20%281%29.jpg',
    title: 'New Garage Build with Decorative Gable',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/r9bdh1f6_Photo%2020-01-2026%2C%2020%2050%2032%20%282%29.jpg',
    title: 'Garage with Decorative Gable & Roller Door',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/12ozteys_Photo%2020-01-2026%2C%2020%2050%2023%20%281%29.jpg',
    title: 'Newly Built Garden Storage',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/gajqn2jp_Photo%2020-01-2026%2C%2020%2049%2059%20%286%29.jpg',
    title: 'New Roof Installation with Velux Windows',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/zg26c1b7_Photo%2020-01-2026%2C%2020%2050%2001.jpg',
    title: 'Rear Extension with Skylight Installation',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/kbokv75z_Photo%2020-01-2026%2C%2020%2050%2000.jpg',
    title: 'Attic Conversion',
    category: 'Conversions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/ynev8f9o_Photo%2020-01-2026%2C%2020%2050%2002%20%282%29.jpg',
    title: 'New Kitchen Installation',
    category: 'Renovations'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/s2zxrtf3_Photo-20-01-2026%2C-20-49-59-%282%29.jpg',
    title: 'Wetroom Installation',
    category: 'Renovations'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/2v8id7l7_Photo%2020-01-2026%2C%2020%2050%2000%20%282%29.jpg',
    title: 'New Fire Door Installation',
    category: 'Renovations'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/m9lpnud8_Photo%2020-01-2026%2C%2020%2050%2000%20%283%29.jpg',
    title: 'New Door Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/kuctcrsu_Photo%2020-01-2026%2C%2020%2050%2012%20%282%29.jpg',
    title: 'Rear Extension with Door Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/3r97eo41_Photo%2020-01-2026%2C%2020%2050%2005.jpg',
    title: 'Chimney Modernisation',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/5vigmwmk_Photo-20-01-2026%2C-20-50-11-%282%29.jpg',
    title: 'Chimney Rebuild & Repointing',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/upr6bsv1_Photo%2020-01-2026%2C%2020%2050%2006%20%281%29.jpg',
    title: 'Chimney Brickwork',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/6gppeaaa_Photo-20-01-2026%2C-20-50-34.jpg',
    title: 'Front Garden Wall with Decorative Brickwork',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/w3n89o8z_Photo%2020-01-2026%2C%2020%2051%2059.jpg',
    title: 'Front Garden Brickwork & Steps',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/g1ynfshd_Photo-20-01-2026%2C-20-50-48-%281%29.jpg',
    title: 'Stepped Party Wall - Expert Brickwork',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/1pl2hnne_Photo%2020-01-2026%2C%2020%2050%2004%20%283%29.jpg',
    title: 'Brickwork Detail - Yellow Stock Brick',
    category: 'Brickwork'
  },
  // === QUALITY ROOFING WORK ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/hdtm1nrl_Photo%2020-01-2026%2C%2020%2050%2002%20%284%29.jpg',
    title: 'Quality Roofing - Attention to Detail',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/36wjo852_Photo%2020-01-2026%2C%2020%2050%2001%20%282%29.jpg',
    title: 'EPDM Rubber Roofing Installation',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/pnzir3pn_Photo%2020-01-2026%2C%2020%2050%2001%20%281%29.jpg',
    title: 'Professional Flat Roof Waterproofing',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/dwa4g4sc_Photo%2020-01-2026%2C%2020%2050%2001%20%283%29.jpg',
    title: 'Flat Roof Insulation & Membrane Work',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/9iapk2pb_Photo%2020-01-2026%2C%2020%2050%2003%20%282%29.jpg',
    title: 'Professional Membrane Installation',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/tjkxr3lc_Photo%2020-01-2026%2C%2020%2050%2004%20%284%29.jpg',
    title: 'Roofing Work - Detail Finishing',
    category: 'Roofing'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/jk759i81_Photo%2020-01-2026%2C%2020%2050%2003%20%281%29.jpg',
    title: 'Brickwork and Foundation Membrane',
    category: 'Roofing'
  },
  // === PROFESSIONAL INSTALLATIONS ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/uhbmkfuz_Photo%2020-01-2026%2C%2020%2050%2030.jpg',
    title: 'Extension with Steel Beam Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/bpdcfao3_Photo%2020-01-2026%2C%2020%2051%2056%20%283%29.jpg',
    title: 'Structural Steel Beam & Joist Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/6cxwgk6v_Photo-20-01-2026%2C-20-50-50-%281%29.jpg',
    title: 'Structural Alteration - Steel Beam Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/719naqlj_Photo%2020-01-2026%2C%2020%2050%2011.jpg',
    title: 'Wall Installation on Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/sqw6llq2_Photo%2020-01-2026%2C%2020%2050%2008.jpg',
    title: 'Outbuilding Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/hfa8lb2a_Photo%2020-01-2026%2C%2020%2050%2014.jpg',
    title: 'Pipe Installation',
    category: 'Renovations'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/go3lw8gj_Photo%2020-01-2026%2C%2020%2050%2012.jpg',
    title: 'External Pipe Work',
    category: 'Extensions'
  },
  // === CONVERSIONS ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/eabib8mz_Photo%2020-01-2026%2C%2020%2050%2012%20%281%29.jpg',
    title: 'Attic Insulation Install on Attic Conversion',
    category: 'Conversions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/naca4eds_Photo-20-01-2026%2C-20-49-59.jpg',
    title: 'Loft Conversion - Structural Beams',
    category: 'Conversions'
  },
  // === WORK IN PROGRESS (Showing Process) ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/yrf69e76_Van.jpg',
    title: 'Our Work Van',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/8r5ayq2t_Photo%2020-01-2026%2C%2020%2049%2058.jpg',
    title: 'New Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/odllmvln_Photo-20-01-2026%2C-20-50-09.jpg',
    title: 'Porch Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/cjui8ru8_Photo%2020-01-2026%2C%2020%2050%2002%20%283%29.jpg',
    title: 'Rear Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/nbuewz6i_Photo-20-01-2026%2C-20-50-39.jpg',
    title: 'Garden Room with Cedar Cladding - In Progress',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/yrbw2xq7_Photo-20-01-2026%2C-20-50-48-%281%29.jpg',
    title: 'Stepped Party Wall Construction',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/evms4ce9_Photo%2020-01-2026%2C%2020%2051%2058%20%281%29.jpg',
    title: 'Extension with Brick Pier - Work in Progress',
    category: 'Brickwork'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/zn00o7hy_Photo-20-01-2026%2C-20-50-04.jpg',
    title: 'Extension Interior - Plasterboard Stage',
    category: 'Renovations'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/f30uf424_Photo%2020-01-2026%2C%2020%2050%2003.jpg',
    title: 'Expert Team - Insulation Board Work',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/1wlwmnwv_Photo%2020-01-2026%2C%2020%2050%2004%20%282%29.jpg',
    title: 'Precision Measuring & Installation',
    category: 'Extensions'
  },
  // === CONSTRUCTION PHASES ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/rrirfk6g_Photo%2020-01-2026%2C%2020%2050%2039%20%283%29.jpg',
    title: 'Two-Storey Extension Under Construction',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/2nzn3jf7_Photo%2020-01-2026%2C%2020%2051%2055%20%281%29.jpg',
    title: 'Detached Bungalow Extension Under Construction',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/2899xo0k_Photo%2020-01-2026%2C%2020%2050%2039%20%281%29.jpg',
    title: 'External Two-Storey Extension Under Construction',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/z87l4p31_Photo%2020-01-2026%2C%2020%2050%2015.jpg',
    title: 'Single Storey Extension - Construction',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/yjjjun0b_Photo%2020-01-2026%2C%2020%2051%2054%20%285%29.jpg',
    title: 'Extension Construction - Active Build Site',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/8toa8q5m_Photo%2020-01-2026%2C%2020%2052%2000.jpg',
    title: 'Rear Extension Project In Progress',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/v0942ayf_Photo%2020-01-2026%2C%2020%2051%2054%20%284%29.jpg',
    title: 'Rear Extension - Brickwork in Progress',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/iv90av96_Photo%2020-01-2026%2C%2020%2050%2039%20%283%29.jpg',
    title: 'Two-Storey Extension Framework',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/mpgpk54r_Photo%2020-01-2026%2C%2020%2050%2000%20%281%29.jpg',
    title: 'Beams in Place for Extension',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/amf6bxme_Photo-20-01-2026%2C-20-51-56-%282%29.jpg',
    title: 'Extension Build - Structural Stage',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/2fdi59jx_Photo%2020-01-2026%2C%2020%2050%2015%20%281%29.jpg',
    title: 'Extension Build - Blockwork Stage',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/i5sgc477_Photo-20-01-2026%2C-20-51-56.jpg',
    title: 'Extension Blockwork Progress',
    category: 'Extensions'
  },
  // === STRUCTURAL & FRAMEWORK ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/4tmjpsw1_Photo%2020-01-2026%2C%2020%2050%2010.jpg',
    title: 'Side Extension - Structural Frame',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/j7tgzzfa_Photo-20-01-2026%2C-20-50-11-%281%29.jpg',
    title: 'Timber Frame Extension Structure',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/3ymfy016_Photo%2020-01-2026%2C%2020%2050%2002%20%285%29.jpg',
    title: 'Timber Frame Construction from Above',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/57gtmgz4_Photo%2020-01-2026%2C%2020%2050%2017%20%281%29.jpg',
    title: 'Extension Frame - Timber Structure',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/eel1322p_Photo-20-01-2026%2C-20-50-48.jpg',
    title: 'Extension Roof Structure - Timber Joists',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/7y159433_Photo-20-01-2026%2C-20-50-48.jpg',
    title: 'Rear Extension - Timber Joists Installation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/mrleylw1_Photo-20-01-2026%2C-20-50-48.jpg',
    title: 'Extension Timber Joist Work',
    category: 'Extensions'
  },
  // === FOUNDATIONS ===
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/1pi3do2b_Photo%2020-01-2026%2C%2020%2050%2020.jpg',
    title: 'Extension Foundation - Concrete Base',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/m89yewuu_Photo-20-01-2026%2C-20-50-46-%281%29.jpg',
    title: 'Rear Extension - Blockwork & Foundations',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/k2wdvaa8_Photo-20-01-2026%2C-20-50-02.jpg',
    title: 'Extension Foundation - Base Work',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/6svmgoym_Photo-20-01-2026%2C-20-51-56-%281%29.jpg',
    title: 'Extension Foundation & Blockwork',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/l9voaqtl_Photo%2020-01-2026%2C%2020%2050%2000%20%284%29.jpg',
    title: 'Single Storey Extension Foundation',
    category: 'Extensions'
  },
  {
    image: 'https://customer-assets.emergentagent.com/job_capital-roofing/artifacts/f6xwjgii_Photo%2020-01-2026%2C%2020%2050%2007%20%281%29.jpg',
    title: 'Foundation Excavation & Preparation',
    category: 'Extensions'
  }
];

export const categories = ['All', 'Extensions', 'Roofing', 'Renovations', 'Conversions', 'Brickwork'];
